export default __webpack_public_path__ + "static/media/0010.5e989a63.svg";